import React from "react";
import { getWindowConfig } from "../config/windowTypeConfigs";
import ArchitecturalDiagram from "./ArchitecturalDiagram";
import AwningDiagram from "./AwningDiagram";
import BasementSliderDiagram from "./BasementSliderDiagram";
import BayDiagram from "./BayDiagram";
import BowDiagram from "./BowDiagram";
import SingleCasementDiagram from "./SingleCasementDiagram";
import TwoLiteCasementDiagram from "./TwoLiteCasementDiagram";
import ThreeLiteCasementDiagram from "./ThreeLiteCasementDiagram";
import FourLiteCasementDiagram from "./FourLiteCasementDiagram";
import DoubleHungDiagram from "./DoubleHungDiagram";
import GardenDiagram from "./GardenDiagram";
import PictureDiagram from "./PictureDiagram";
import TwoPartSliderDiagram from "./TwoPartSliderDiagram";
import ThreePartSliderDiagram from "./ThreePartSliderDiagram";
import TwoLiteSlidingDoorDiagram from "./TwoLiteSlidingDoorDiagram";
import ThreeLiteSlidingDoorDiagram from "./ThreeLiteSlidingDoorDiagram";

const WindowDiagram = ({
  windowTypeName,
  selectedValue,
  availableOptions,
  onChange,
  mode,
  disabled,
  formData,
  allAvailableOptions,
}) => {
  const config = getWindowConfig(windowTypeName);
  const diagramName = config.diagram;

  const diagramComponents = {
    ArchitecturalDiagram: ArchitecturalDiagram,
    AwningDiagram: AwningDiagram,
    BasementSliderDiagram: BasementSliderDiagram,
    BayDiagram: BayDiagram,
    BowDiagram: BowDiagram,
    SingleCasementDiagram: SingleCasementDiagram,
    TwoLiteCasementDiagram: TwoLiteCasementDiagram,
    ThreeLiteCasementDiagram: ThreeLiteCasementDiagram,
    FourLiteCasementDiagram: FourLiteCasementDiagram,
    DoubleHungDiagram: DoubleHungDiagram,
    GardenDiagram: GardenDiagram,
    PictureDiagram: PictureDiagram,
    TwoPartSliderDiagram: TwoPartSliderDiagram,
    ThreePartSliderDiagram: ThreePartSliderDiagram,
    TwoLiteSlidingDoorDiagram: TwoLiteSlidingDoorDiagram,
    ThreeLiteSlidingDoorDiagram: ThreeLiteSlidingDoorDiagram,
  };

  const DiagramComponent = diagramComponents[diagramName];

  if (!DiagramComponent) {
    console.warn(`No diagram component found for: ${diagramName}`);

    return (
      <div data-testid="window-diagram">
        <SingleCasementDiagram
          selectedValue={selectedValue}
          availableOptions={availableOptions}
          onChange={onChange}
          mode={mode}
        />
      </div>
    );
  }

  return (
    <div data-testid="window-diagram">
      <DiagramComponent
        selectedValue={selectedValue}
        availableOptions={availableOptions}
        onChange={onChange}
        mode={mode}
        disabled={disabled}
        formData={formData}
        allAvailableOptions={allAvailableOptions}
      />
    </div>
  );
};

export default WindowDiagram;
